let timer: number | undefined;
export function toast(msg: string, kind?: 'success' | 'danger' | 'warn') {
  const el = document.getElementById('toast');
  if (!el) return;
  el.textContent = msg;
  el.className = 'toast show' + (kind ? ' toast-' + kind : '');
  clearTimeout(timer);
  timer = window.setTimeout(() => el.classList.remove('show'), 2400);
}
